import Icons from "assets";

export const TEXT_ALIGNMENT_OPTIONS = [
  {
    label: (
      <div className="py-1 flex justify-center">
        <Icons.TextAlignLeft />
      </div>
    ),
    value: "left",
  },
  {
    label: (
      <div className="py-1 flex justify-center">
        <Icons.TextAlignCenter />
      </div>
    ),
    value: "center",
  },
  {
    label: (
      <div className="py-1 flex justify-center">
        <Icons.TextAlignLeft className="rotate-180" />
      </div>
    ),
    value: "right",
  },
  {
    label: (
      <div className="py-1 flex justify-center">
        <Icons.TextAlignJustified />
      </div>
    ),
    value: "justify",
  },
];
